import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EvRepositoryApi } from "../../apiclient/api/EvRepositoryApi";
var repositoryApi = new EvRepositoryApi();
export var fetchBaskets = createAsyncThunk("baskets/get", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var response, ids, count, entities;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return repositoryApi.getCollectionResource("baskets", {
            size: "1000"
          });
        case 2:
          response = _context.sent;
          ids = [];
          count = response.page.totalElements;
          entities = {};
          response._embedded.baskets.forEach(function (element) {
            ids.push(element.id.docId);
            entities[element.id.docId] = element;
          });
          return _context.abrupt("return", {
            count: count,
            ids: ids,
            entities: entities
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
export var removeBasket = createAsyncThunk("baskets/remove", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(docid, thunkApi) {
    var basket, _id, _response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            basket = thunkApi.getState().baskets.entities[docid];
            if (!basket) {
              _context2.next = 9;
              break;
            }
            _id = basket._links.self.href.replace(/.*\//, "");
            _context2.next = 5;
            return repositoryApi.deleteItemResource("baskets", _id);
          case 5:
            _response = _context2.sent;
            return _context2.abrupt("return", {
              count: 1,
              id: docid
            });
          case 9:
            return _context2.abrupt("return", {
              count: 0
            });
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
export var addBasket = createAsyncThunk("baskets/add", /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(attrs, thunkApi) {
    var _response2;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(thunkApi.getState().baskets.count < 1000)) {
              _context3.next = 7;
              break;
            }
            _context3.next = 3;
            return repositoryApi.postCollectionResource(attrs, "baskets");
          case 3:
            _response2 = _context3.sent;
            return _context3.abrupt("return", {
              count: 1,
              id: attrs.id.docId,
              entity: _response2
            });
          case 7:
            return _context3.abrupt("return", {
              count: 0,
              message: "You have already selected a maximum of 1000 records. You can view all currently selected records by clicking 'Selected records'."
            });
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}());
var initialState = {
  status: "init",
  count: 0,
  entities: {},
  ids: []
};
var basketsSlice = createSlice({
  name: "baskets",
  initialState: initialState,
  reducers: {
    // omit reducer cases
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchBaskets.pending, function (state) {
      state.status = "pending";
    }).addCase(fetchBaskets.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      state.status = "done";
      state.count = payload.count;
      state.ids = payload.ids;
      state.entities = payload.entities;
    }).addCase(fetchBaskets.rejected, function (state) {
      state.status = "error";
    }).addCase(removeBasket.pending, function (state) {
      state.status = "pending";
    }).addCase(removeBasket.fulfilled, function (state, _ref5) {
      var payload = _ref5.payload;
      state.status = "done";
      if (payload.count === 1) {
        var _pos = state.ids.indexOf(payload.id);
        if (_pos > -1) {
          delete state.entities[payload.id];
          state.count -= 1;
          state.ids = state.ids.filter(function (id) {
            return id in state.entities;
          });
        }
      }
    }).addCase(removeBasket.rejected, function (state) {
      state.status = "error";
    }).addCase(addBasket.pending, function (state) {
      state.status = "pending";
    }).addCase(addBasket.fulfilled, function (state, _ref6) {
      var payload = _ref6.payload;
      state.status = "done";
      state.count += 1;
      state.ids.push(payload.id);
      state.entities[payload.id] = payload.entity;
    }).addCase(addBasket.rejected, function (state) {
      state.status = "error";
    });
  }
});
export var selectBasketsStatus = function selectBasketsStatus(state) {
  return state.baskets.status;
};
export var selectBasketsCount = function selectBasketsCount(state) {
  return state.baskets.count;
};
export var selectBasketsState = function selectBasketsState(state) {
  return state.baskets;
};
export default basketsSlice.reducer;